//@state
export interface profileState {
  tabs: any[];
}

export const initialState: profileState = {
  tabs: [],
};
